import { useEffect, useRef } from 'react';

/**
 * Run an effect after deps settle (reduces burst API calls on fast state updates).
 */
export function useDebouncedEffect(effect, deps, delayMs = 400) {
  const effectRef = useRef(effect);
  effectRef.current = effect;

  useEffect(() => {
    let cleanup;
    const timer = setTimeout(() => {
      cleanup = effectRef.current();
    }, delayMs);

    return () => {
      clearTimeout(timer);
      if (typeof cleanup === 'function') cleanup();
    };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, deps);
}
